
import { defuFn } from '/home/vsts/work/1/s/UI/mycim-app/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
